import { SEND_RECOMMEND_OFFICE_EMAIL } from '../constants/recommendOfficeType';

export function sendRecommendOfficeEmail(params) {
  return {
    type: SEND_RECOMMEND_OFFICE_EMAIL,
    payload: params
  };
}



// WEBPACK FOOTER //
// ./app/actions/recommendOfficeActions.js